/* ============================================================
   ILS — All reviews page renderer (TASK-1715).
   ============================================================ */
(function(){
  'use strict';

  if(!document.querySelector('[data-ils-rp]')) return;

  /* TASK-2886: locale-aware root (e.g. "" on the primary domain, "/lv-lv" on a
     localized storefront). Same helper pattern as custom-cart-page.js. Used so
     /products/{handle}.js is resolved under the current locale prefix — a
     localized (translated) handle only exists under its locale path, and the
     bare `/products/{handle}.js` there 404s (or returns the wrong product),
     which is why deep-linked lv reviews pulled the English title. */
  function localeRoot(){
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (typeof r === 'string' && r.length > 0) {
        var trimmed = r.replace(/\/+$/, '');
        return trimmed === '' ? '' : trimmed;
      }
    } catch (e) {}
    return '';
  }

  var STAR_PATH = 'M12 2.6c.55 0 1.04.33 1.27.83l2.3 4.96 5.43.7c.55.07.99.45 1.16.97.16.51-.01 1.07-.42 1.43l-4.02 3.52 1.06 5.4c.1.54-.12 1.08-.57 1.4-.45.31-1.04.34-1.52.07L12 18.86l-4.69 2.61c-.48.27-1.07.24-1.52-.07-.45-.32-.67-.86-.57-1.4l1.06-5.4-4.02-3.52c-.41-.36-.58-.92-.42-1.43.17-.52.61-.9 1.16-.97l5.43-.7 2.3-4.96c.23-.5.72-.83 1.27-.83z';
  function starSvg(state){
    if(state==='full'){
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+STAR_PATH+'"/></svg>';
    }
    if(state==='dim'){
      return '<svg viewBox="0 0 24 24" class="dim" aria-hidden="true"><path d="'+STAR_PATH+'"/></svg>';
    }
    var gid='hg'+Math.random().toString(36).slice(2,8);
    return '<svg viewBox="0 0 24 24" aria-hidden="true">'+
      '<defs><linearGradient id="'+gid+'"><stop offset="50%" stop-color="var(--star)"/><stop offset="50%" stop-color="var(--star-dim)"/></linearGradient></defs>'+
      '<path d="'+STAR_PATH+'" fill="url(#'+gid+')"/></svg>';
  }
  function starsRow(rate){
    rate = parseFloat(rate)||0;
    var html='';
    for(var i=1;i<=5;i++){
      if(rate>=i)        html+=starSvg('full');
      else if(rate>=i-.5)html+=starSvg('half');
      else               html+=starSvg('dim');
    }
    return '<span class="pstars">'+html+'</span>';
  }
  function starOne(){
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+STAR_PATH+'"/></svg>';
  }

  var FLAGS = {
    DE:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#000"/><rect width="5" height="1" y="1" fill="#D00"/><rect width="5" height="1" y="2" fill="#FFCE00"/></svg>',
    LV:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="3" fill="#9E3039"/><rect width="5" height="1" y="1" fill="#fff"/></svg>',
    EE:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#0072CE"/><rect width="5" height="1" y="1" fill="#000"/><rect width="5" height="1" y="2" fill="#fff"/></svg>',
    LT:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#FDB913"/><rect width="5" height="1" y="1" fill="#006A44"/><rect width="5" height="1" y="2" fill="#C1272D"/></svg>',
    AT:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#ED2939"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#ED2939"/></svg>',
    BE:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#000"/><rect width="3" height="6" x="3" fill="#FAE042"/><rect width="3" height="6" x="6" fill="#ED2939"/></svg>',
    BG:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#fff"/><rect width="5" height="1" y="1" fill="#00966E"/><rect width="5" height="1" y="2" fill="#D62612"/></svg>',
    HR:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#FF0000"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#171796"/></svg>',
    CY:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="9" height="6" fill="#fff"/><path d="M3.7 2.2 L5.3 2.2 L5.3 2.9 L4.8 2.9 L4.8 3.4 L4.2 3.4 L4.2 2.9 L3.7 2.9 Z" fill="#D57800"/><path d="M3.5 4 L5.5 4" stroke="#4E5B31" stroke-width=".25"/></svg>',
    CZ:'<svg viewBox="0 0 6 4" preserveAspectRatio="none"><rect width="6" height="2" fill="#fff"/><rect width="6" height="2" y="2" fill="#D7141A"/><path d="M0 0 L3 2 L0 4 Z" fill="#11457E"/></svg>',
    DK:'<svg viewBox="0 0 37 28" preserveAspectRatio="none"><rect width="37" height="28" fill="#C8102E"/><rect width="37" height="4" y="12" fill="#fff"/><rect width="4" height="28" x="12" fill="#fff"/></svg>',
    FI:'<svg viewBox="0 0 18 11" preserveAspectRatio="none"><rect width="18" height="11" fill="#fff"/><rect width="3" height="11" x="5" fill="#003580"/><rect width="18" height="3" y="4" fill="#003580"/></svg>',
    FR:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#0055A4"/><rect width="3" height="6" x="3" fill="#fff"/><rect width="3" height="6" x="6" fill="#EF4135"/></svg>',
    GR:'<svg viewBox="0 0 27 18" preserveAspectRatio="none"><rect width="27" height="18" fill="#0D5EAF"/><rect width="27" height="2" y="2" fill="#fff"/><rect width="27" height="2" y="6" fill="#fff"/><rect width="27" height="2" y="10" fill="#fff"/><rect width="27" height="2" y="14" fill="#fff"/><rect width="10" height="10" fill="#0D5EAF"/><rect width="10" height="2" y="4" fill="#fff"/><rect width="2" height="10" x="4" fill="#fff"/></svg>',
    HU:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#CD2A3E"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#436F4D"/></svg>',
    IE:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#169B62"/><rect width="3" height="6" x="3" fill="#fff"/><rect width="3" height="6" x="6" fill="#FF883E"/></svg>',
    IT:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#009246"/><rect width="3" height="6" x="3" fill="#fff"/><rect width="3" height="6" x="6" fill="#CE2B37"/></svg>',
    LU:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#ED2939"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#00A1DE"/></svg>',
    MT:'<svg viewBox="0 0 6 4" preserveAspectRatio="none"><rect width="3" height="4" fill="#fff"/><rect width="3" height="4" x="3" fill="#CF142B"/></svg>',
    NL:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#AE1C28"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#21468B"/></svg>',
    PL:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1.5" fill="#fff"/><rect width="5" height="1.5" y="1.5" fill="#DC143C"/></svg>',
    PT:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="9" height="6" fill="#FF0000"/><rect width="3.6" height="6" fill="#006600"/><circle cx="3.6" cy="3" r=".7" fill="#FFD700" stroke="#000" stroke-width=".08"/></svg>',
    RO:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#002B7F"/><rect width="3" height="6" x="3" fill="#FCD116"/><rect width="3" height="6" x="6" fill="#CE1126"/></svg>',
    SK:'<svg viewBox="0 0 6 4" preserveAspectRatio="none"><rect width="6" height="1.34" fill="#fff"/><rect width="6" height="1.34" y="1.34" fill="#0B4EA2"/><rect width="6" height="1.34" y="2.66" fill="#EE1C25"/></svg>',
    SI:'<svg viewBox="0 0 6 4" preserveAspectRatio="none"><rect width="6" height="1.34" fill="#fff"/><rect width="6" height="1.34" y="1.34" fill="#0000A5"/><rect width="6" height="1.34" y="2.66" fill="#ED1C24"/></svg>',
    ES:'<svg viewBox="0 0 10 7" preserveAspectRatio="none"><rect width="10" height="7" fill="#AA151B"/><rect width="10" height="3.5" y="1.75" fill="#F1BF00"/></svg>',
    SE:'<svg viewBox="0 0 18 11" preserveAspectRatio="none"><rect width="18" height="11" fill="#006AA7"/><rect width="2" height="11" x="5" fill="#FECC00"/><rect width="18" height="2" y="4.5" fill="#FECC00"/></svg>'
  };

  var CC_CAROUSEL = [
    { cc:'de', name:'Germany'    },
    { cc:'lv', name:'Latvia'     },
    { cc:'ee', name:'Estonia'    },
    { cc:'lt', name:'Lithuania'  },
    { cc:'at', name:'Austria'    },
    { cc:'be', name:'Belgium'    },
    { cc:'bg', name:'Bulgaria'   },
    { cc:'hr', name:'Croatia'    },
    { cc:'cy', name:'Cyprus'     },
    { cc:'cz', name:'Czechia'    },
    { cc:'dk', name:'Denmark'    },
    { cc:'fi', name:'Finland'    },
    { cc:'fr', name:'France'     },
    { cc:'gr', name:'Greece'     },
    { cc:'hu', name:'Hungary'    },
    { cc:'ie', name:'Ireland'    },
    { cc:'it', name:'Italy'      },
    { cc:'lu', name:'Luxembourg' },
    { cc:'mt', name:'Malta'      },
    { cc:'nl', name:'Netherlands'},
    { cc:'pl', name:'Poland'     },
    { cc:'pt', name:'Portugal'   },
    { cc:'ro', name:'Romania'    },
    { cc:'sk', name:'Slovakia'   },
    { cc:'si', name:'Slovenia'   },
    { cc:'es', name:'Spain'      },
    { cc:'se', name:'Sweden'     }
  ];

  function initFlagsCarousel(root){
    var carousels = root.querySelectorAll('[data-ilsrp-cc]');
    carousels.forEach(function(rc){
      if (rc.dataset.ccReady) return;
      rc.dataset.ccReady = '1';

      var vp    = rc.querySelector('[data-cc-vp]');
      var track = rc.querySelector('[data-cc-track]');
      if (!vp || !track) return;
      var items = Array.prototype.slice.call(track.children);
      var n = items.length;
      if (!n) return;

      var AUTO_MS = 2000, RESUME_MS = 5000;
      var active = 0, autoTimer = null, resumeTimer = null;

      function itemW(){ return items[0].offsetWidth || 120; }

      function render(){
        var w = itemW();
        var offset = -(active * w) - w/2;
        track.style.transform = 'translateX(' + offset + 'px)';
        for (var i=0;i<n;i++){
          items[i].classList.toggle('is-active', i === active);
        }
      }

      function goTo(i, manual){
        active = ((i % n) + n) % n;
        render();
        if (manual) pauseAuto();
      }
      function step(dir, manual){ goTo(active + dir, manual); }

      function startAuto(){
        stopAutoTimer();
        autoTimer = setInterval(function(){ step(1, false); }, AUTO_MS);
      }
      function stopAutoTimer(){ if (autoTimer){ clearInterval(autoTimer); autoTimer = null; } }
      function pauseAuto(){
        stopAutoTimer();
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(startAuto, RESUME_MS);
      }

      items.forEach(function(el, i){
        el.addEventListener('click', function(){
          if (i !== active) goTo(i, true);
        });
      });

      var startX = 0, dragging = false, movedX = 0;
      function down(x){ startX = x; dragging = true; movedX = 0; }
      function move(x){ if (dragging) movedX = x - startX; }
      function up(){
        if (!dragging) return;
        dragging = false;
        if (Math.abs(movedX) > 30) step(movedX < 0 ? 1 : -1, true);
      }
      vp.addEventListener('touchstart', function(e){ down(e.touches[0].clientX); }, {passive:true});
      vp.addEventListener('touchmove',  function(e){ move(e.touches[0].clientX); }, {passive:true});
      vp.addEventListener('touchend',   function(){ up(); });
      vp.addEventListener('mousedown',  function(e){ down(e.clientX); });
      window.addEventListener('mousemove', function(e){ move(e.clientX); });
      window.addEventListener('mouseup',   function(){ up(); });
      vp.addEventListener('click', function(e){
        if (Math.abs(movedX) > 8) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      window.addEventListener('resize', render);
      render();
      startAuto();
    });
  }

  var VERIFIED_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">'+
      '<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 14.4L5.6 11.2l1.7-1.7 3.5 3.5 6.9-6.9 1.7 1.7-8.6 8.6z"/>'+
    '</svg>';

  /* Localized "verified" labels. English defaults; overridden in init() from
     the [data-ils-rp] root's data-verified-label / data-verified-review-label
     attributes emitted by custom-reviews-page.liquid via `| t` (TASK-2566). */
  var VERIFIED_WORD = 'verified';
  var VERIFIED_ARIA = 'Verified review';
  var MULTI_PHOTO_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">'+
      '<path d="M4 7h12v11H4zM7 4h12v11h-1V7H7z"/>'+
    '</svg>';
  var TAG_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">'+
      '<path d="M21 11.5 12.5 3H4v8.5L12.5 20l8.5-8.5zM8 9.5A1.5 1.5 0 1 1 8 6.5a1.5 1.5 0 0 1 0 3z"/>'+
    '</svg>';
  var TRUCK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+
      '<path d="M3 7h11v9H3z"/>'+
      '<path d="M14 10h4l3 3v3h-7"/>'+
      '<circle cx="7"  cy="17" r="1.6" fill="currentColor"/>'+
      '<circle cx="17" cy="17" r="1.6" fill="currentColor"/>'+
    '</svg>';

  var DEMO_REVIEWS = [];

  function init(root){
    // Localized "verified" labels from the root section (TASK-2566); EN fallback.
    VERIFIED_WORD = (root && root.getAttribute('data-verified-label')) || VERIFIED_WORD;
    VERIFIED_ARIA = (root && root.getAttribute('data-verified-review-label')) || VERIFIED_ARIA;

    /* TASK-2886: translatable UI strings piped in from the section root's
       data-* attributes (emitted via `| t` in custom-reviews-page.liquid), same
       mechanism as the verified labels above. English fallbacks kept inline so
       the page still reads correctly if an attribute is missing. */
    function attr(name, fallback){
      var v = root && root.getAttribute(name);
      return (v != null && v !== '') ? v : fallback;
    }
    var I18N = {
      basedOn:             attr('data-summary-based-on',      'Based on'),
      reviewsWord:         attr('data-summary-reviews-word',  'customer reviews'),
      reviewWord:          attr('data-summary-review-word',   'customer review'),
      ordersDelivered:     attr('data-orders-delivered',      'orders delivered'),
      delivering:          attr('data-delivering',            'Delivering'),
      acrossEurope:        attr('data-across-europe',         'across Europe'),
      eu27Note:            attr('data-eu27-note',             'EU-27 - we ship across Europe'),
      noReviewsYetProduct: attr('data-no-reviews-yet-product','No reviews yet for this product.'),
      noReviewsMatch:      attr('data-no-reviews-match',      'No reviews match this filter.'),
      noReviewsPage:       attr('data-no-reviews-page',       'No reviews on this page.'),
      loadingReviews:      attr('data-loading-reviews',       'Loading reviews…'),
      loadError:           attr('data-load-error',            'Couldn’t load reviews. Please try again.'),
      loadErrorProduct:    attr('data-load-error-product',    'Couldn’t load reviews for this product. Please try again.')
    };
    var CC_NAMES = {};
    try { CC_NAMES = JSON.parse((root && root.getAttribute('data-cc-names')) || '{}') || {}; }
    catch(e){ CC_NAMES = {}; }

    var cfg      = window.ILS_REVIEWS_PAGE || {};
    var apiBase  = (typeof cfg.apiBase === 'string' && cfg.apiBase) ? cfg.apiBase.replace(/\/+$/, '') : '';
    var perPage  = (typeof cfg.perPage === 'number' && cfg.perPage > 0) ? cfg.perPage : 20;
    var reviews  = [];
    var avg      = (typeof cfg.average === 'number') ? cfg.average : 4.82;
    var count    = (typeof cfg.totalCount === 'number') ? cfg.totalCount : 1240;
    var orders   = (typeof cfg.totalOrders === 'number') ? cfg.totalOrders : 14000;
    /* TASK-5677: the canonical, always-current "orders delivered" figure is
       {apiBase}/api/orders/count — the SAME endpoint the PDP sticky marquee and
       the homepage social-proof block read through custom-orders-count-live.js.
       The `orders` seed above is the section setting `summary_orders`
       (Liquid-rendered, hand-typed); until this task it was the ONLY value this
       page ever had, so the tile froze on whatever thousand was true when the
       setting was last edited — 14.000+ since 2026-07-11 — while the PDP kept
       moving. It now serves only as the first-frame / API-down fallback.
       `ordersFormatted` keeps the server's `formatted` string verbatim so the
       rounding rule and the thousands separator stay in exactly ONE place
       (ils-admin/orders_routes.js) for every surface that shows the number.
       Why the value lives in state and not in the DOM: renderSummary() rebuilds
       #ils-rp-summary with innerHTML several times per page life (summary
       response, product filter apply/clear, deep-link hydration), so the global
       painter custom-orders-count-live.js could never hold a value here — its
       paint would be wiped by the next rebuild. Holding it in state means every
       later re-render reads the fresh number instead. */
    var ordersFormatted = null;
    var ordersCountSent = false;
    var totalPages   = 1;
    var currentPage  = readPageFromUrl();
    /* TASK-2886: guards against stale feed responses overwriting fresh ones.
       A deep-link without &pid= fires a handle-only load first, then a second
       (product_id) load once hydrateProductMetaForDeepLink resolves the id;
       only the latest issued request is allowed to render. */
    var loadSeq = 0;

    var state = {
      sort:'date',
      stars:new Set(),
      productFilter: readProductFromUrl(),
      productId:     readProductIdFromUrl(),
      productTitle:  '',
      productImage:  ''
    };

    function readPageFromUrl(){
      try {
        var p = parseInt(new URL(window.location.href).searchParams.get('page'), 10);
        return (p && p > 0) ? p : 1;
      } catch (e) { return 1; }
    }
    function readProductFromUrl(){
      try {
        var h = new URL(window.location.href).searchParams.get('product') || '';
        return String(h).trim().toLowerCase();
      } catch (e) { return ''; }
    }
    /* TASK-2886: locale-independent numeric product id passed on the deep-link
       from the PDP (&pid=). Lets the by-product query filter by product_id
       instead of the localized handle the proxy index can't resolve. */
    function readProductIdFromUrl(){
      try {
        var p = new URL(window.location.href).searchParams.get('pid') || '';
        p = String(p).trim();
        return /^\d+$/.test(p) ? p : '';
      } catch (e) { return ''; }
    }
    function setProductInUrl(handle){
      try {
        var u = new URL(window.location.href);
        if(handle){
          u.searchParams.set('product', handle);
          u.searchParams.delete('page');
          // TASK-2886: mirror the numeric product_id into the URL so a
          // reload/shared link keeps filtering locale-independently.
          if(state.productId){ u.searchParams.set('pid', state.productId); }
          else { u.searchParams.delete('pid'); }
        } else {
          u.searchParams.delete('product');
          u.searchParams.delete('pid');
        }
        window.history.replaceState({}, '', u.toString());
      } catch(e) { /* no-op */ }
    }

    function $(sel){ return root.querySelector(sel); }
    function $$(sel){ return root.querySelectorAll(sel); }

    function formatRate(n){ return n.toFixed(2).replace('.', ','); }
    function formatThousands(n){ return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    /* TASK-5677: single source for the orders tile's text. The server-provided
       `formatted` wins when present — identical precedence to
       custom-orders-count-live.js, so if the backend ever changes the rounding
       or the separator, PDP / homepage / this page all change together. Local
       formatting is only the fallback path and must never become the primary
       one: duplicating floor((n-1000)/1000)*1000 in the theme is exactly how
       the two numbers drifted apart in the first place. */
    function ordersText(){
      return ordersFormatted || (formatThousands(orders)+'+');
    }
    function formatDateDot(iso){
      if(!iso) return '';
      var parts = iso.split('-');
      if(parts.length !== 3) return iso;
      var dd = parts[2].length === 1 ? '0' + parts[2] : parts[2];
      var mm = parts[1].length === 1 ? '0' + parts[1] : parts[1];
      return dd + '.' + mm + '.' + parts[0];
    }
    function escapeHtml(str){
      if(typeof str !== 'string') return '';
      return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function renderSummaryTopStore(){
      var html = '';
      html += '<div class="summary-top">';
      html +=   '<div class="summary-stars">'+starsRow(avg)+'</div>';
      html +=   '<div class="summary-num">'+formatRate(avg)+'</div>';
      html +=   '<div class="summary-base">'+escapeHtml(I18N.basedOn)+' <b>'+formatThousands(count)+'</b> '+escapeHtml(I18N.reviewsWord)+'</div>';
      html += '</div>';
      return html;
    }
    function renderSummaryTopProduct(){
      var title  = state.productTitle || state.productFilter;
      var loaded = (typeof state.productTotal === 'number');
      var total  = loaded ? state.productTotal : 0;
      var avgP   = (typeof state.productAvg === 'number' && isFinite(state.productAvg)) ? state.productAvg : 0;

      var html = '';
      html += '<div class="summary-top summary-top--product">';
      if(!loaded){
        html += '<div class="summary-stars">'+starsRow(0)+'</div>';
        html += '<div class="summary-num" style="font-size:22px;">'+escapeHtml(I18N.loadingReviews)+'</div>';
      } else {
        html += '<div class="summary-stars">'+starsRow(avgP)+'</div>';
        html += '<div class="summary-num">'+formatRate(avgP)+'</div>';
      }
      if(loaded && total > 0){
        html += '<div class="summary-base">'+escapeHtml(I18N.basedOn)+' <b>'+formatThousands(total)+'</b> '+escapeHtml(total===1?I18N.reviewWord:I18N.reviewsWord)+'</div>';
      }
      html +=   '<div class="summary-title-product">';
      html +=     '<span class="summary-title-name">'+escapeHtml(title)+'</span>';
      html +=   '</div>';
      html += '</div>';
      return html;
    }
    function renderSummaryBottom(){
      var html = '';
      html += '<div class="summary-divider"></div>';
      html += '<div class="summary-row">';
      html +=   '<div class="summary-cell">';
      html +=     '<div class="summary-ic">'+
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+
                      '<rect x="3" y="6" width="18" height="13" rx="2"/>'+
                      '<path d="M8 6V4h8v2"/>'+
                    '</svg>'+
                  '</div>';
      html +=     '<div class="summary-meta">';
      html +=       '<div class="summary-big" data-ils-orders-big>'+escapeHtml(ordersText())+'</div>';
      html +=       '<div class="summary-sub">'+escapeHtml(I18N.ordersDelivered)+'</div>';
      html +=     '</div>';
      html +=   '</div>';
      html +=   '<div class="summary-cell">';
      html +=     '<div class="summary-ic">'+TRUCK_SVG+'</div>';
      html +=     '<div class="summary-meta">';
      html +=       '<div class="summary-big">'+escapeHtml(I18N.delivering)+'</div>';
      html +=       '<div class="summary-sub">'+escapeHtml(I18N.acrossEurope)+'</div>';
      html +=     '</div>';
      html +=   '</div>';
      html += '</div>';
      html += '<div class="summary-flags" aria-label="EU member states">';
      html +=   '<div class="ils-rp-cc" data-ilsrp-cc>';
      html +=     '<div class="ils-rp-cc__viewport" data-cc-vp>';
      html +=       '<div class="ils-rp-cc__track" data-cc-track>';
      CC_CAROUSEL.forEach(function(c){
        var ccName = CC_NAMES[c.cc] || c.name;
        html +=       '<div class="ils-rp-cc__item" data-cc="'+c.cc+'" data-name="'+escapeHtml(ccName)+'">';
        html +=         '<span class="ils-rp-cc__flag"><img src="https://flagcdn.com/w160/'+c.cc+'.png" alt="" loading="lazy" width="160" height="107"></span>';
        html +=         '<span class="ils-rp-cc__name">'+escapeHtml(ccName)+'</span>';
        html +=       '</div>';
      });
      html +=       '</div>';
      html +=     '</div>';
      html +=   '</div>';
      html +=   '<div class="summary-flags-note">'+escapeHtml(I18N.eu27Note)+'</div>';
      html += '</div>';
      return html;
    }
    function renderSummary(){
      var s = $('#ils-rp-summary');
      if(!s) return;
      var top = state.productFilter ? renderSummaryTopProduct() : renderSummaryTopStore();
      s.innerHTML = top + renderSummaryBottom();
      initFlagsCarousel(s);
    }

    function hydrateStarChips(){
      var ic = starOne();
      $$('#ils-rp-stars .star-ic').forEach(function(slot){ slot.innerHTML = ic; });
    }

    var filterToggle  = $('#ils-rp-filter-toggle');
    var filterModal   = document.getElementById('ils-rp-filter-modal');
    var filterClose   = filterModal ? filterModal.querySelector('.ils-rp-fmodal-close') : null;
    var filterCountEl = $('#ils-rp-filter-count');
    var fbSort        = $('#ils-rp-sort');
    var fbStars       = $('#ils-rp-stars');
    var fpClear       = $('#ils-rp-clear');
    var feedEl        = $('#ils-rp-feed');
    var pagiEl        = $('#ils-rp-pagi');

    function openFilterModal(){
      if(!filterModal) return;
      filterModal.classList.add('is-open');
      filterToggle && filterToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeFilterModal(){
      if(!filterModal) return;
      filterModal.classList.remove('is-open');
      filterToggle && filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if(filterToggle){ filterToggle.addEventListener('click', openFilterModal); }
    if(filterClose){ filterClose.addEventListener('click', closeFilterModal); }
    if(filterModal){
      filterModal.addEventListener('click', function(ev){
        if(ev.target === filterModal) closeFilterModal();
      });
    }
    document.addEventListener('keydown', function(ev){
      if(ev.key === 'Escape' && filterModal && filterModal.classList.contains('is-open')){
        closeFilterModal();
      }
    });

    if(fbSort){
      fbSort.addEventListener('click', function(ev){
        var btn = ev.target.closest('.fb-chip');
        if(!btn) return;
        state.sort = btn.getAttribute('data-sort');
        fbSort.querySelectorAll('.fb-chip').forEach(function(c){
          var on = c === btn;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        renderFeed();
        syncFilterMeta();
      });
    }

    var allChip   = fbStars ? fbStars.querySelector('[data-stars="all"]') : null;
    var starChips = fbStars ? Array.prototype.slice.call(fbStars.querySelectorAll('.fb-chip[data-stars]:not([data-stars="all"])')) : [];

    if(fbStars){
      fbStars.addEventListener('click', function(ev){
        var btn = ev.target.closest('.fb-chip');
        if(!btn) return;
        var v = btn.getAttribute('data-stars');
        if(v === 'all'){
          state.stars.clear();
        } else {
          var n = parseInt(v, 10);
          if(state.stars.has(n)) state.stars.delete(n);
          else state.stars.add(n);
        }
        syncStarChips();
        renderFeed();
        syncFilterMeta();
      });
    }

    function syncStarChips(){
      if(!allChip) return;
      var noneSelected = state.stars.size === 0;
      allChip.classList.toggle('is-on', noneSelected);
      allChip.setAttribute('aria-pressed', noneSelected ? 'true' : 'false');
      starChips.forEach(function(c){
        var n = parseInt(c.getAttribute('data-stars'), 10);
        var on = state.stars.has(n);
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    if(fpClear){
      fpClear.addEventListener('click', function(){
        if(fpClear.hasAttribute('disabled')) return;
        state.sort = 'date';
        state.stars.clear();
        fbSort.querySelectorAll('.fb-chip').forEach(function(c){
          var on = c.getAttribute('data-sort') === 'date';
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        syncStarChips();
        renderFeed();
        syncFilterMeta();
      });
    }

    function syncFilterMeta(){
      var count2 = state.stars.size + (state.sort === 'date' ? 0 : 1);
      if(filterCountEl){
        if(count2 > 0){
          filterCountEl.hidden = false;
          filterCountEl.textContent = count2;
        } else {
          filterCountEl.hidden = true;
        }
      }
      if(fpClear){
        if(count2 > 0) fpClear.removeAttribute('disabled');
        else          fpClear.setAttribute('disabled', 'disabled');
      }
    }

    function getList(){
      var list = reviews.slice();
      if(state.stars.size > 0){
        list = list.filter(function(r){ return state.stars.has(Math.floor(r.rate)); });
      }
      if(state.sort === 'rate'){
        list.sort(function(a,b){
          if(b.rate !== a.rate) return b.rate - a.rate;
          return (b.date||'').localeCompare(a.date||'');
        });
      } else {
        list.sort(function(a,b){ return (b.date||'').localeCompare(a.date||''); });
      }
      return list;
    }

    function renderSlideInner(p){
      if(typeof p === 'string'){
        return '<img src="'+escapeHtml(p)+'" loading="lazy" alt="">';
      }
      if(p && typeof p === 'object' && p.em){
        return '<span class="em">'+p.em+'</span>';
      }
      return '';
    }
    function slideClass(p, isFirst){
      var cls = 'rev-slide';
      if(p && typeof p === 'object' && p.bg) cls += ' ' + p.bg;
      if(isFirst) cls += ' on';
      return cls;
    }

    function buildPhotoBlock(r){
      var photos = Array.isArray(r.photos) ? r.photos.filter(Boolean) : [];
      if(photos.length){
        var h = '<div class="rev-photo">';
        photos.forEach(function(p, i){
          h += '<div class="'+slideClass(p, i===0)+'">'+renderSlideInner(p)+'</div>';
        });
        if(photos.length > 1){
          h += '<div class="rev-pips">';
          photos.forEach(function(_, i){
            h += '<i'+(i===0?' class="on"':'')+'></i>';
          });
          h += '</div>';
          h += '<div class="rev-photocount">'+MULTI_PHOTO_SVG+'<span>'+photos.length+'</span></div>';
        }
        h += '</div>';
        return h;
      }
      if(r.product && r.product.bg && r.product.em){
        var pp = r.product;
        return '<div class="rev-photo">'+
                 '<div class="rev-slide '+pp.bg+' on"><span class="em">'+pp.em+'</span></div>'+
                 '<div class="rev-prodbadge" title="Product photo">'+TAG_SVG+'<span>product</span></div>'+
               '</div>';
      }
      return '';
    }

    function renderFeed(){
      if(!feedEl) return;
      var list = getList();
      if(!list.length){
        feedEl.innerHTML = '<div class="feed-empty">'+escapeHtml(I18N.noReviewsMatch)+'</div>';
        return;
      }
      var html = '';
      list.forEach(function(r){
        html += '<article class="rev-card" data-id="'+r.id+'">';
        html += buildPhotoBlock(r);
        html += '<div class="rev-body">';
        html +=   '<div class="rev-rating">'+starsRow(r.rate)+
                  '<span class="rev-date">'+formatDateDot(r.date)+'</span></div>';
        html +=   '<p class="rev-text">'+escapeHtml(r.text)+'</p>';
        html +=   '<div class="rev-author">';
        if(r.flag && FLAGS[r.flag]){
          html += '<span class="rev-flag">'+FLAGS[r.flag]+'</span>';
        }
        html +=   '<span class="rev-meta">';
        html +=     '<span class="rev-name">'+escapeHtml(r.name||'')+(r.surname?' '+escapeHtml(r.surname).charAt(0)+'.':'')+'</span>';
        html +=   '</span>';
        if(r.verified){
          html += '<span class="rev-verified" aria-label="'+escapeHtml(VERIFIED_ARIA)+'">'+
                    VERIFIED_SVG+'<span>'+escapeHtml(VERIFIED_WORD)+'</span>'+
                  '</span>';
        }
        html +=   '</div>';
        html += '</div>';
        html += '</article>';
      });
      feedEl.innerHTML = html;
    }

    setInterval(function(){
      root.querySelectorAll('.rev-card').forEach(function(card){
        var slides = card.querySelectorAll('.rev-photo > .rev-slide');
        if(slides.length < 2) return;
        var pips = card.querySelectorAll('.rev-pips i');
        var cur = 0;
        slides.forEach(function(s, i){ if(s.classList.contains('on')) cur = i; });
        var next = (cur + 1) % slides.length;
        slides[cur].classList.remove('on');
        slides[next].classList.add('on');
        if(pips.length){
          if(pips[cur]) pips[cur].classList.remove('on');
          if(pips[next % pips.length]) pips[next % pips.length].classList.add('on');
        }
      });
    }, 2000);

    var modal      = document.getElementById('ils-rp-modal');
    var modalBody  = modal ? modal.querySelector('.ils-rp-modal-body') : null;
    var modalClose = modal ? modal.querySelector('.ils-rp-modal-close') : null;
    var modalRotateId = null;

    function openModal(reviewId){
      if(!modal || !modalBody) return;
      var r = reviews.find(function(x){ return String(x.id) === String(reviewId); });
      if(!r) return;

      var html = '';
      var hasCustomerPhotos = r.photos && r.photos.length > 0;

      if(hasCustomerPhotos){
        html += '<div class="rv-modal-photo" id="ils-rp-modal-photo">';
        r.photos.forEach(function(p, i){
          html += '<div class="'+slideClass(p, i===0)+'">'+renderSlideInner(p)+'</div>';
        });
        if(r.photos.length > 1){
          html += '<div class="rev-pips">';
          r.photos.forEach(function(_, i){ html += '<i'+(i===0?' class="on"':'')+'></i>'; });
          html += '</div>';
        }
        html += '</div>';
      } else if(r.product && r.product.bg && r.product.em){
        var pp = r.product;
        html += '<div class="rv-modal-photo" id="ils-rp-modal-photo">';
        html +=   '<div class="rev-slide '+pp.bg+' on"><span class="em">'+pp.em+'</span></div>';
        html +=   '<div class="rev-prodbadge" title="Product photo">'+TAG_SVG+'<span>product</span></div>';
        html += '</div>';
      }

      html += '<div class="rv-modal-info">';
      html +=   '<div class="rv-modal-row1">';
      html +=     starsRow(r.rate);
      html +=     '<span class="rev-date">'+formatDateDot(r.date)+'</span>';
      if(r.verified){
        html +=   '<span class="rev-verified" aria-label="'+escapeHtml(VERIFIED_ARIA)+'">'+
                    VERIFIED_SVG+'<span>'+escapeHtml(VERIFIED_WORD)+'</span>'+
                  '</span>';
      }
      html +=   '</div>';
      html +=   '<p class="rv-modal-text">'+escapeHtml(r.text||'')+'</p>';

      if(!hasCustomerPhotos && r.product && r.product.title){
        html += '<div class="rv-modal-prodline">'+
                  '<span class="rev-prodbadge">'+TAG_SVG+'<span>product photo</span></span>'+
                  '<span>Linked product: <b>'+escapeHtml(r.product.title)+'</b></span>'+
                '</div>';
      }

      html +=   '<div class="rv-modal-author">';
      if(r.flag && FLAGS[r.flag]){
        html += '<span class="rev-flag">'+FLAGS[r.flag]+'</span>';
      }
      html +=   '<span class="rev-meta">';
      html +=     '<span class="rev-name">'+escapeHtml(r.name||'')+(r.surname?' '+escapeHtml(r.surname).charAt(0)+'.':'')+'</span>';
      html +=   '</span>';
      html +=   '</div>';
      html += '</div>';

      modalBody.innerHTML = html;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      if(modalRotateId) clearInterval(modalRotateId);
      modalRotateId = setInterval(function(){
        var photoEl = document.getElementById('ils-rp-modal-photo');
        if(!photoEl) return;
        var slides = photoEl.querySelectorAll('.rev-slide');
        if(slides.length < 2) return;
        var pips = photoEl.querySelectorAll('.rev-pips i');
        var cur = 0;
        slides.forEach(function(s, i){ if(s.classList.contains('on')) cur = i; });
        var next = (cur + 1) % slides.length;
        slides[cur].classList.remove('on');
        slides[next].classList.add('on');
        if(pips.length){
          if(pips[cur]) pips[cur].classList.remove('on');
          if(pips[next % pips.length]) pips[next % pips.length].classList.add('on');
        }
      }, 2000);
    }

    function closeModal(){
      if(!modal) return;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if(modalRotateId){ clearInterval(modalRotateId); modalRotateId = null; }
    }

    if(feedEl){
      feedEl.addEventListener('click', function(ev){
        var card = ev.target.closest('.rev-card');
        if(!card) return;
        var id = card.getAttribute('data-id');
        if(!id) return;
        openModal(id);
      });
    }
    if(modalClose) modalClose.addEventListener('click', closeModal);
    if(modal){
      modal.addEventListener('click', function(ev){
        if(ev.target === modal) closeModal();
      });
    }
    document.addEventListener('keydown', function(ev){
      if(ev.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
    });

    function mapApiReview(a){
      return {
        id:        a.id,
        rate:      parseFloat(a.rating) || 0,
        text:      a.body || '',
        date:      a.date || '',
        name:      a.name || '',
        surname:   a.surname || '',
        verified:  !!a.verified,
        flag:      (a.country || '').toUpperCase(),
        photos:    Array.isArray(a.photos) ? a.photos.slice() : [],
        product:   a.product ? { title: a.product.title, handle: a.product.handle } : null
      };
    }

    function showFeedMessage(msg){
      if(feedEl) feedEl.innerHTML = '<div class="feed-empty">'+escapeHtml(msg)+'</div>';
    }

    function pageUrl(p){
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('page', String(p));
        u.hash = 'ils-rp-feed';
        return u.toString();
      } catch (e) {
        var sep = window.location.search.indexOf('?') >= 0 ? '&' : '?';
        return window.location.pathname + window.location.search + sep + 'page=' + p + '#ils-rp-feed';
      }
    }

    function computeParts(cur, total){
      var out = [];
      if(total <= 7){
        for(var i=1; i<=total; i++) out.push(i);
        return out;
      }
      out.push(1);
      if(cur > 3) out.push('\u2026');
      var start = Math.max(2, cur - 1);
      var end   = Math.min(total - 1, cur + 1);
      for(var j=start; j<=end; j++) out.push(j);
      if(cur < total - 2) out.push('\u2026');
      out.push(total);
      return out;
    }

    function buildPaginationBar(cur, total){
      if(!pagiEl) return;
      if(!total || total <= 1){ pagiEl.innerHTML = ''; return; }
      var anchor = '#ils-rp-feed';
      var prevSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
      var nextSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
      var chevSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

      var html = '<nav class="ils-pg" role="navigation" aria-label="Pagination" data-anchor="'+anchor+'">';
      html += '<div class="ils-pg__row">';

      if(cur > 1){
        html += '<a class="ils-pg__arrow" href="'+pageUrl(cur-1)+'" aria-label="Previous">'+prevSvg+'</a>';
      } else {
        html += '<span class="ils-pg__arrow is-disabled" aria-hidden="true">'+prevSvg+'</span>';
      }

      computeParts(cur, total).forEach(function(p){
        if(p === '\u2026'){
          html += '<span class="ils-pg__dots" aria-hidden="true">\u2026</span>';
        } else if(p === cur){
          html += '<span class="ils-pg__num is-cur" aria-current="page">'+p+'</span>';
        } else {
          html += '<a class="ils-pg__num" href="'+pageUrl(p)+'">'+p+'</a>';
        }
      });

      if(cur < total){
        html += '<a class="ils-pg__arrow" href="'+pageUrl(cur+1)+'" aria-label="Next">'+nextSvg+'</a>';
      } else {
        html += '<span class="ils-pg__arrow is-disabled" aria-hidden="true">'+nextSvg+'</span>';
      }

      html += '</div>';

      html += '<button type="button" class="ils-pg__picker" data-ils-pagi-picker' +
              ' data-total="'+total+'" data-current="'+cur+'" data-anchor="'+anchor+'"' +
              ' aria-label="Go to page">' +
                '<span class="cur">'+cur+'</span><span class="slash">/</span><span class="tot">'+total+'</span>' +
                chevSvg +
              '</button>';

      html += '</nav>';
      pagiEl.innerHTML = html;
    }

    /* TASK-5677: fetch the canonical orders count once per page load, then
       update the tile. Deliberately NOT inside loadStoreFeed(): the
       product-filtered branch (/pages/reviews?handle=… — where every PDP "see
       all reviews" link lands) never calls /api/reviews/summary at all, yet it
       renders the very same tile through renderSummaryBottom(). Hanging this
       off loadAndRender() covers both modes from one call site.
       `ordersCountSent` makes the request fire exactly once even though
       loadAndRender() also runs on applyProductFilter() / clearProductFilter():
       a filter toggle has no reason to re-ask, and the stored value is reused
       by the re-render for free.
       No loadSeq-style ordering guard is needed (unlike the review feed): only
       one request is ever in flight, and the answer is written to STATE, so no
       later renderSummary() can resurrect the stale seed and no late response
       can clobber a fresher one.
       Failure is silent by design — 502 / offline / CORS / garbage body all
       leave `orders` untouched, so the tile keeps the Liquid fallback instead
       of ever showing NaN, "undefined", or an invented number. */
    function loadOrdersCount(){
      if(ordersCountSent) return;
      if(!apiBase) return;                 // nothing to ask — keep the fallback
      ordersCountSent = true;
      fetch(apiBase + '/api/orders/count', { credentials: 'omit' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          if(!data) return;
          var raw = parseInt(data.orders_delivered, 10);
          if(!isFinite(raw) || raw < 0) return;
          /* Accept the server string only if it really is a number-ish label
             (digits, group separators, optional trailing "+"). It ends up in the
             summary markup, so anything else is dropped in favour of local
             formatting rather than trusted. */
          var fmt = (typeof data.formatted === 'string' && /^[0-9.,\u00a0\u202f ]+\+?$/.test(data.formatted))
            ? data.formatted
            : null;
          if(raw === orders && fmt === ordersFormatted) return;   // nothing to repaint
          orders = raw;
          ordersFormatted = fmt;
          /* Targeted repaint: renderSummary() would also work, but it rebuilds
             the whole tile (and re-inits the flag carousel) for a two-character
             change. The [data-ils-orders-big] hook is emitted by
             renderSummaryBottom(), so it exists in every render mode; if it is
             somehow missing we fall back to a full re-render. */
          var big = $('[data-ils-orders-big]');
          if(big) big.textContent = ordersText();
          else renderSummary();
        })
        .catch(function(){ /* keep the Liquid fallback */ });
    }

    function loadAndRender(){
      loadOrdersCount();
      if(state.productFilter){
        loadProductFilteredFeed();
      } else {
        loadStoreFeed();
      }
    }

    function loadStoreFeed(){
      var mySeq = ++loadSeq;
      if(feedEl){
        feedEl.innerHTML = '<div class="feed-empty">'+escapeHtml(I18N.loadingReviews)+'</div>';
      }
      if(pagiEl) pagiEl.innerHTML = '';

      var feedUrl    = apiBase + '/api/reviews?page=' + currentPage + '&per_page=' + perPage;
      var summaryUrl = apiBase + '/api/reviews/summary';

      fetch(summaryUrl, { credentials: 'omit' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          if(data && typeof data.average === 'number') avg = data.average;
          if(data && typeof data.count_total_raw === 'number' && data.count_total_raw > 0) {
            count = data.count_total_raw;
          } else if(data && typeof data.count === 'number' && data.count > 0) {
            count = data.count;
          }
          renderSummary();
        })
        .catch(function(){ /* keep fallback values */ });

      fetch(feedUrl, { credentials: 'omit' })
        .then(function(r){
          if(!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function(data){
          if(mySeq !== loadSeq) return; // superseded by a newer load (TASK-2886)
          var apiReviews = (data && Array.isArray(data.reviews)) ? data.reviews : [];
          reviews = apiReviews.map(mapApiReview);
          totalPages = (data && typeof data.total_pages === 'number' && data.total_pages > 0)
            ? data.total_pages
            : Math.max(1, Math.ceil(((data && data.total) || reviews.length) / perPage));
          if(!reviews.length){
            showFeedMessage(I18N.noReviewsPage);
          } else {
            renderFeed();
          }
          buildPaginationBar(currentPage, totalPages);
        })
        .catch(function(err){
          if(mySeq !== loadSeq) return; // superseded by a newer load (TASK-2886)
          reviews = [];
          totalPages = 1;
          showFeedMessage(I18N.loadError);
        });
    }

    function loadProductFilteredFeed(){
      var mySeq = ++loadSeq;
      if(feedEl){
        feedEl.innerHTML = '<div class="feed-empty">'+escapeHtml(I18N.loadingReviews)+'</div>';
      }
      if(pagiEl) pagiEl.innerHTML = '';

      var PROD_LIMIT = 100;
      /* TASK-2886: pass BOTH handle and the locale-independent product_id (when
         known \u2014 from the &pid= deep-link, the search dropdown, or resolved via
         hydrateProductMetaForDeepLink). The proxy index is keyed on the
         canonical handle + product_id, so a localized (translated) handle on
         lv/other locales resolves 0 reviews on its own \u2014 exactly the bug this
         fixes. Mirrors custom-pdp-reviews-by-product.js. */
      var qs = 'handle=' + encodeURIComponent(state.productFilter);
      if(state.productId){ qs += '&product_id=' + encodeURIComponent(state.productId); }
      qs += '&limit=' + PROD_LIMIT;
      var url = apiBase + '/api/reviews/by-product?' + qs;

      fetch(url, { credentials: 'omit' })
        .then(function(r){
          if(!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function(data){
          if(mySeq !== loadSeq) return; // superseded by a newer load (TASK-2886)
          var apiReviews = (data && Array.isArray(data.reviews)) ? data.reviews : [];
          reviews = apiReviews.map(mapApiReview);
          state.productTotal = (data && typeof data.total_for_product === 'number')
            ? data.total_for_product
            : reviews.length;
          if(reviews.length){
            var sum = 0;
            for(var i=0;i<reviews.length;i++) sum += (reviews[i].rate || 0);
            state.productAvg = sum / reviews.length;
          } else {
            state.productAvg = 0;
          }
          if(reviews[0] && reviews[0].product && reviews[0].product.title){
            /* TASK-2995 (replaces cancelled TASK-2994): the Railway/Judge.me proxy
               returns the ENGLISH product
               title. Use it ONLY as a fallback — never let it clobber a
               localized title already resolved from the search dropdown
               (applyProductFilter) or /{locale}/products/{handle}.js
               (hydrateProductMetaForDeepLink). At this point state.productTitle is
               still the raw handle placeholder (seeded = state.productFilter on
               deep-link) or empty only when no localized title has been set. */
            if(!state.productTitle || state.productTitle === state.productFilter){
              state.productTitle = reviews[0].product.title;
            }
            updateFilterBadge();
          }
          renderSummary();
          totalPages = 1;
          if(!reviews.length){
            showFeedMessage(I18N.noReviewsYetProduct);
          } else {
            renderFeed();
          }
          if(pagiEl) pagiEl.innerHTML = '';
        })
        .catch(function(err){
          if(mySeq !== loadSeq) return; // superseded by a newer load (TASK-2886)
          state.productTotal = 0;
          state.productAvg = 0;
          renderSummary();
          showFeedMessage(I18N.loadErrorProduct);
        });
    }

    var pSearchRoot   = $('[data-ils-rp-psearch]');
    var pSearchOpener = pSearchRoot ? pSearchRoot.querySelector('[data-ils-rp-psearch-open]') : null;
    var pSearchInput  = document.querySelector('[data-ils-rp-psearch-input]');
    var pSearchDrop   = document.querySelector('[data-ils-rp-psearch-dropdown]');
    var pSearchClear  = document.querySelector('[data-ils-rp-psearch-clear]');
    var pSearchBadge  = pSearchRoot ? pSearchRoot.querySelector('[data-ils-rp-psearch-badge]') : null;
    var pSearchBadgeName = pSearchBadge ? pSearchBadge.querySelector('[data-ils-rp-psearch-badge-name]') : null;
    var pSearchReset  = pSearchBadge ? pSearchBadge.querySelector('[data-ils-rp-psearch-reset]') : null;
    var pmodal        = document.querySelector('[data-ils-rp-psearch-modal]');
    var pmodalOverlay = pmodal ? pmodal.querySelector('[data-ils-rp-psearch-modal-overlay]') : null;
    var pmodalClose   = pmodal ? pmodal.querySelector('[data-ils-rp-psearch-modal-close]') : null;

    function openPmodal(){
      if(!pmodal) return;
      pmodal.hidden = false;
      document.body.style.overflow = 'hidden';
      if(pSearchInput){ pSearchInput.value = ''; }
      if(pSearchClear) pSearchClear.hidden = true;
      hideDropdown();
      setTimeout(function(){ if(pSearchInput) pSearchInput.focus(); }, 30);
    }
    function closePmodal(){
      if(!pmodal) return;
      pmodal.hidden = true;
      document.body.style.overflow = '';
      hideDropdown();
    }

    var suggestAbort = null;
    var suggestDebounce = null;
    var lastSuggestQuery = '';
    var productReviewsCache = new Map();

    function hideDropdown(){
      if(!pSearchDrop) return;
      pSearchDrop.hidden = true;
      pSearchDrop.innerHTML = '';
    }
    function showDropdownHtml(html){
      if(!pSearchDrop) return;
      pSearchDrop.innerHTML = html;
      pSearchDrop.hidden = false;
    }

    function renderSuggestions(products){
      if(!products || !products.length){
        showDropdownHtml('<div class="ils-rp-psearch__hint">No matching products.</div>');
        return;
      }
      var n = products.length;
      var html = '<div class="ils-rp-psearch__resultshead">Found '+n+' '+(n===1?'product':'products')+'. Tap one to filter reviews:</div>';
      products.forEach(function(p){
        var img = p.image ? '<img src="'+escapeHtml(p.image)+'" loading="lazy" alt="">' : '';
        html += '<button type="button" class="ils-rp-psearch__item" ' +
                  'data-handle="'+escapeHtml(p.handle)+'" ' +
                  'data-id="'+escapeHtml(p.id || '')+'" ' +
                  'data-title="'+escapeHtml(p.title)+'" ' +
                  'data-image="'+escapeHtml(p.image || '')+'" ' +
                  'role="option">';
        html +=   '<span class="ils-rp-psearch__thumb">'+img+'</span>';
        html +=   '<span class="ils-rp-psearch__meta">';
        html +=     '<span class="ils-rp-psearch__title">'+escapeHtml(p.title)+'</span>';
        html +=   '</span>';
        html += '</button>';
      });
      showDropdownHtml(html);
    }

    /* TASK-2042: URL is built from window.routes.predictive_search_url when
       available (locale-prefixed on localized storefronts), and encoded via
       URLSearchParams so bracket params survive any 302 that Shopify's
       "storefront routing" throws in on the primary domain \u2014 hitting the
       raw `/search/suggest.json` there redirected to `/lv-lv/search/...`
       AND collapsed the nested `resources[options][fields]` into a
       Ruby-hash-literal string, yielding a 422 "expected String to be a
       Hash". Using the locale-aware base path skips that redirect.
       TASK-2052: After Shopify returns candidates, drop any product that has
       zero Judge.me reviews \u2014 the search dropdown on /pages/reviews must
       only surface products the user can actually filter reviews by. The
       backend has no bulk exists-check, so we fan out one small
       /api/reviews/by-product?limit=1 per candidate and read
       `total_for_product`. Results cached per session to keep repeat queries
       cheap; the same suggestAbort signal is threaded through so a new
       keystroke cancels the in-flight review checks too. */
    function checkProductHasReviews(handle, productId, signal){
      if(!apiBase || (!handle && !productId)) return Promise.resolve(false);
      var cacheKey = productId ? ('id:' + productId) : ('h:' + handle);
      if(productReviewsCache.has(cacheKey)) return Promise.resolve(productReviewsCache.get(cacheKey));
      /* TASK-2886: prefer the locale-independent product_id (from Shopify
         predictive search) so the exists-check works on localized storefronts
         where the handle is translated and the proxy can't resolve it. */
      var qs = [];
      if(handle) qs.push('handle=' + encodeURIComponent(handle));
      if(productId) qs.push('product_id=' + encodeURIComponent(productId));
      qs.push('limit=1');
      var u = apiBase + '/api/reviews/by-product?' + qs.join('&');
      var opts = { credentials:'omit', headers:{ 'Accept':'application/json' } };
      if(signal) opts.signal = signal;
      return fetch(u, opts)
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          var has = !!(data && (
            (typeof data.total_for_product === 'number' && data.total_for_product > 0) ||
            (Array.isArray(data.reviews) && data.reviews.length > 0)
          ));
          productReviewsCache.set(cacheKey, has);
          return has;
        })
        .catch(function(){ return false; });
    }

    function fetchSuggestions(q){
      if(suggestAbort){ try { suggestAbort.abort(); } catch(e){} }
      suggestAbort = ('AbortController' in window) ? new AbortController() : null;
      var signal = suggestAbort ? suggestAbort.signal : null;

      var base = (window.routes && typeof window.routes.predictive_search_url === 'string' && window.routes.predictive_search_url)
        ? window.routes.predictive_search_url
        : '/search/suggest';
      var params = new URLSearchParams();
      params.set('q', q);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '10');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor');
      var url = base + '.json?' + params.toString();

      var opts = { credentials:'same-origin', headers:{ 'Accept':'application/json' } };
      if(signal) opts.signal = signal;

      showDropdownHtml('<div class="ils-rp-psearch__hint">Searching\u2026</div>');

      fetch(url, opts)
        .then(function(r){
          if(!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function(data){
          if(q !== lastSuggestQuery) return null;
          var products = (data && data.resources && data.resources.results && Array.isArray(data.resources.results.products))
            ? data.resources.results.products
            : [];
          var norm = products.map(function(p){
            return {
              handle: p.handle || '',
              // TASK-2886: keep the locale-independent numeric id so the
              // exists-check and, later, the by-product feed can filter by it.
              id:     (p.id != null) ? String(p.id) : '',
              title:  p.title  || '',
              image:  p.featured_image && p.featured_image.url ? p.featured_image.url
                    : (p.image || '')
            };
          }).filter(function(p){ return p.handle; });
          if(!norm.length) return [];
          return Promise.all(norm.map(function(p){
            return checkProductHasReviews(p.handle, p.id, signal);
          })).then(function(flags){
            return norm.filter(function(_, i){ return flags[i]; });
          });
        })
        .then(function(filtered){
          if(filtered == null) return;
          if(q !== lastSuggestQuery) return;
          renderSuggestions(filtered);
        })
        .catch(function(err){
          if(err && err.name === 'AbortError') return;
          if(window.console && console.warn){
            console.warn('[ils-rp] product search failed:', err, 'url=', url);
          }
          showDropdownHtml('<div class="ils-rp-psearch__hint">Search failed. Please try again.</div>');
        });
    }

    function applyProductFilter(handle, title, image, productId){
      handle = String(handle || '').trim().toLowerCase();
      if(!handle){ clearProductFilter(); return; }
      state.productFilter = handle;
      // TASK-2886: keep the numeric product_id from the search result so the
      // by-product feed filters locale-independently.
      state.productId     = /^\d+$/.test(String(productId || '')) ? String(productId) : '';
      state.productTitle  = title || handle;
      state.productImage  = image || '';
      state.productTotal  = null;
      state.productAvg    = null;
      currentPage = 1;

      setProductInUrl(handle);
      updateFilterBadge();
      hideDropdown();
      closePmodal();
      loadAndRender();
    }

    function clearProductFilter(){
      state.productFilter = '';
      state.productId     = '';
      state.productTitle  = '';
      state.productImage  = '';
      state.productTotal  = null;
      state.productAvg    = null;
      setProductInUrl('');
      updateFilterBadge();
      hideDropdown();
      if(pSearchInput) pSearchInput.value = '';
      if(pSearchClear) pSearchClear.hidden = true;
      renderSummary();
      loadAndRender();
    }

    function updateFilterBadge(){
      var active = !!state.productFilter;
      if(pSearchOpener) pSearchOpener.hidden = active;
      if(pSearchBadge){
        pSearchBadge.hidden = !active;
        if(pSearchBadgeName){
          pSearchBadgeName.textContent = state.productTitle || state.productFilter || '';
        }
      }
    }

    function hydrateProductMetaForDeepLink(handle){
      /* TASK-2886: resolve under the current locale prefix. On a localized
         storefront (e.g. lv) the deep-linked handle is the TRANSLATED handle,
         which only exists at `/lv-lv/products/{handle}.js` — the bare
         `/products/{handle}.js` 404s there, so the page used to fall back to the
         English title. Resolving with the locale root returns the localized
         title AND the numeric product id, which we then feed to the by-product
         query so the correct (locale-independent) reviews load. */
      var url = localeRoot() + '/products/' + encodeURIComponent(handle) + '.js';
      fetch(url, { credentials:'same-origin', headers:{ 'Accept':'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){
          if(!p) return;
          if(p.title) state.productTitle = p.title;
          if(p.featured_image) state.productImage = p.featured_image;
          // Capture the locale-independent product id if we didn't already get
          // it from the &pid= deep-link. Re-run the feed so a handle-only load
          // (which returns 0 on localized storefronts) is corrected.
          var resolvedId = (p.id != null) ? String(p.id) : '';
          var needReload = resolvedId && !state.productId;
          if(resolvedId && !state.productId){ state.productId = resolvedId; }
          if(pSearchInput && document.activeElement !== pSearchInput){
            pSearchInput.value = state.productTitle;
          }
          updateFilterBadge();
          if(needReload && state.productFilter){
            setProductInUrl(state.productFilter);
            loadProductFilteredFeed();
          } else if(state.productFilter && !reviews.length){
            renderSummary();
          }
        })
        .catch(function(){ /* keep handle-as-title fallback */ });
    }

    if(pSearchInput){
      pSearchInput.addEventListener('input', function(){
        var q = String(pSearchInput.value || '').trim();
        lastSuggestQuery = q;
        if(pSearchClear) pSearchClear.hidden = q.length === 0;
        if(suggestDebounce) clearTimeout(suggestDebounce);
        if(q.length < 2){
          hideDropdown();
          return;
        }
        suggestDebounce = setTimeout(function(){
          fetchSuggestions(q);
        }, 180);
      });
      pSearchInput.addEventListener('focus', function(){
        var q = String(pSearchInput.value || '').trim();
        if(q.length >= 2 && pSearchDrop && !pSearchDrop.innerHTML){
          fetchSuggestions(q);
        }
      });
      pSearchInput.addEventListener('keydown', function(ev){
        if(ev.key === 'Escape'){ hideDropdown(); }
      });
    }
    if(pSearchDrop){
      pSearchDrop.addEventListener('click', function(ev){
        var btn = ev.target.closest('.ils-rp-psearch__item');
        if(!btn) return;
        var handle = btn.getAttribute('data-handle');
        if(!handle) return;
        applyProductFilter(handle, btn.getAttribute('data-title'), btn.getAttribute('data-image'), btn.getAttribute('data-id'));
      });
    }
    if(pSearchClear){
      pSearchClear.addEventListener('click', function(){
        if(pSearchInput){ pSearchInput.value = ''; pSearchInput.focus(); }
        pSearchClear.hidden = true;
        hideDropdown();
      });
    }
    if(pSearchReset){
      pSearchReset.addEventListener('click', clearProductFilter);
    }
    if(pSearchOpener){
      pSearchOpener.addEventListener('click', openPmodal);
    }
    /* TASK-2057 — click-outside-to-close.
       TASK-2053 moved the dim onto the .ils-rp-pmodal container and left the
       .ils-rp-pmodal__overlay child transparent. In that layout, listening on
       the overlay alone missed clicks that landed on the pmodal container
       itself (e.g. inside its 20px padding ring, and any area the overlay
       didn't cover cleanly under backdrop-filter's stacking context).
       Attach the handler to the pmodal container and close whenever the click
       target is NOT inside the .ils-rp-pmodal__sheet. */
    var pmodalSheet = pmodal ? pmodal.querySelector('.ils-rp-pmodal__sheet') : null;
    if(pmodal){
      pmodal.addEventListener('click', function(ev){
        if(pmodalSheet && !pmodalSheet.contains(ev.target)) closePmodal();
      });
    }
    if(pmodalClose){
      pmodalClose.addEventListener('click', closePmodal);
    }
    if(pSearchInput){
      pSearchInput.addEventListener('keydown', function(ev){
        if(ev.key === 'Enter'){
          var first = pSearchDrop ? pSearchDrop.querySelector('.ils-rp-psearch__item') : null;
          if(first){
            ev.preventDefault();
            var handle = first.getAttribute('data-handle');
            if(handle) applyProductFilter(handle, first.getAttribute('data-title'), first.getAttribute('data-image'), first.getAttribute('data-id'));
          }
        }
      });
    }
    document.addEventListener('keydown', function(ev){
      if(ev.key === 'Escape' && pmodal && !pmodal.hidden) closePmodal();
    });

    renderSummary();
    hydrateStarChips();
    syncFilterMeta();
    if(state.productFilter){
      state.productTitle = state.productFilter;
      updateFilterBadge();
      hydrateProductMetaForDeepLink(state.productFilter);
    } else {
      updateFilterBadge();
    }
    loadAndRender();
  }

  if(document.readyState !== 'loading'){
    document.querySelectorAll('[data-ils-rp]').forEach(init);
  } else {
    document.addEventListener('DOMContentLoaded', function(){
      document.querySelectorAll('[data-ils-rp]').forEach(init);
    });
  }
})();
